import React from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Image from "react-bootstrap/Image";
import { HouseLineIcon } from "./SVGIcon";

const CustomBreadcrumb = ({ items }) => {
  return (
    <Breadcrumb>
      <li className="breadcrumb-item">
        <Link to="/dashboard">
          <HouseLineIcon size={18} />
        </Link>
      </li>
      {items.map((item, index) =>
        item.active ? (
          <li
            className="breadcrumb-item active"
            aria-current="page"
            key={index}
          >
            {item.label}
          </li>
        ) : (
          <li key={index} className="breadcrumb-item">
            {item.href ? (
              <Link to={item.href} onClick={item.onClick}>
                {item.label}
              </Link>
            ) : (
              <Link
                role="button"
                className="breadcrumb-item cursor-pointer"
                onClick={item.onClick}
              >
                {item.label}
              </Link>
            )}
          </li>
        )
      )}
    </Breadcrumb>
  );
};

export default CustomBreadcrumb;
